
const state = {

  zIndex: 1000,

  zIndexId: null

}

const getters = {

  zIndex(state) {
    return state.zIndex;
  },

  zIndexId(state) {
    return state.zIndexId;
  }

}

const mutations = {

  setZIndexId(state, id) {
    state.zIndexId = id;
  }

}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/zIndex.js